/**
 * Subsidy terms: each offer's toggle opens and closes its own panel only, so
 * several can be open at once. Without JS every panel stays open and the
 * toggles stay hidden, so the terms are always readable.
 */
export default function initTerms() {
	const toggles = [...document.querySelectorAll('[data-awdd-terms]')];
	if (!toggles.length) return;
	const panel = (t) => document.getElementById(t.getAttribute('aria-controls'));
	const set = (t, open) => {
		t.setAttribute('aria-expanded', String(open));
		const p = panel(t);
		if (p) p.hidden = !open;
	};
	toggles.forEach((t) => {
		t.hidden = false;
		set(t, false);
		t.addEventListener('click', () => {
			set(t, t.getAttribute('aria-expanded') !== 'true');
		});
	});
}
